import { NEW_MODULE_API } from "../Helpers/Enums";
import globalRequest from "./globalRequest";

const enrichKeywordStringUpdate = async (userId) => {
  await globalRequest("post", NEW_MODULE_API.UPDATE_STRING_AND_KEYWORD_SUGGESTION, { userId: userId }, {}, true);
};

export default enrichKeywordStringUpdate;
